'use client';

import { Text } from '../../../../../components/styled/text';
import { VStack } from '@terra/ui-styled-system';

export function DiscoverySignalOutputBody({ output }: { output: string }) {
  const signalIdMatch = output.match(/\(ID:\s*([^)]+)\)/i);
  const signalId = signalIdMatch?.[1];

  return (
    <VStack alignItems="stretch" gap={1} width="100%">
      <Text fontSize="xs" color="fg.default">
        {output.trim()}
      </Text>
      {signalId ? (
        <Text fontSize="2xs" color="fg.muted" fontFamily="mono">
          {signalId}
        </Text>
      ) : null}
    </VStack>
  );
}
